// 跨标签页同步工具
// 只用于用户操作时的消费通知同步
// 点击 查看 或者 关闭 都会触发 local_push 事件

class CrossTabSync {
  // 同步事件类型
  static DIY_EVENT_NAME = "local_push"

  // 存储键名
  static STORAGE_KEY = 'local_push_ca8628f63b45dfd0b4190477663d24e0'

  constructor() {
    this.init()
  }

  /**
   * 初始化跨标签页同步
   */
  init() {
    // 监听storage事件
    window.addEventListener('storage', this.handleStorageChange.bind(this))
    // console.log('CrossTabSync: 跨标签页同步已初始化')
  }

  /**
   * 处理storage变化事件
   * @param {StorageEvent} event - storage事件
   */
  handleStorageChange(event) {
    // 只处理我们关心的key
    if (event.key !== CrossTabSync.STORAGE_KEY) {
      return
    }

    try {
      const syncData = JSON.parse(event.newValue)
      if (syncData && syncData.type === CrossTabSync.DIY_EVENT_NAME) {
        // console.log('CrossTabSync: 收到消费通知事件:', syncData)
        
        // 触发自定义事件，让MessageNotification组件处理
        window.dispatchEvent(new CustomEvent(CrossTabSync.DIY_EVENT_NAME, {
          detail: syncData
        }))
      }
    } catch (error) {
      console.error('CrossTabSync: 解析同步数据失败:', error)
    }
  }

  /**
   * 广播消费通知事件到其他标签页
   * @param {string} id - 后端推送时的通知ID
   * @param {string} action - 操作类型 ('view' 或 'close')
   */
  broadcastConsumeNotification(id, action) {
    const syncData = {
      type: CrossTabSync.DIY_EVENT_NAME,
      id,
      action: action,
      timestamp: Date.now(),
    }

    try {
      localStorage.setItem(CrossTabSync.STORAGE_KEY, JSON.stringify(syncData))
      // console.log('CrossTabSync: 广播消费通知事件:', syncData)
    } catch (error) {
      // console.error('CrossTabSync: 广播消费通知事件失败:', error)
    }
  }

  /**
   * 清理资源
   */
  cleanup() {
    window.removeEventListener('storage', this.handleStorageChange.bind(this))
    window.removeEventListener('beforeunload', this.cleanup.bind(this))
    // console.log('CrossTabSync: 资源已清理')
  }
}

// 创建全局实例
const crossTabSync = new CrossTabSync()

export { CrossTabSync }
export default crossTabSync


// WEBPACK FOOTER //
// ./src/utils/crossTabSync.js